import { render, staticRenderFns } from "./IncalculationPage.vue?vue&type=template&id=6c7041df&scoped=true"
import script from "./IncalculationPage.vue?vue&type=script&lang=js"
export * from "./IncalculationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7041df",
  null
  
)

export default component.exports